export default __webpack_public_path__ + "static/clouds-36de1996a4c725bcd9a7e941c88a672b.png";